import { Controller } from "@hotwired/stimulus"

// Drives the sticky navbar: exposes how far the page has scrolled as a 0..1
// CSS variable (--scroll) so the stylesheet can shrink and darken the bar
// gradually. Setting it on connect keeps it right after Turbo visits and when
// the browser restores a scrolled position.
export default class extends Controller {
  static values = { distance: { type: Number, default: 96 } }

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    cancelAnimationFrame(this.frame)
  }

  onScroll() {
    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => this.update())
  }

  update() {
    const progress = Math.min(Math.max(window.scrollY / this.distanceValue, 0), 1)
    this.element.style.setProperty("--scroll", progress.toFixed(3))
  }
}
